// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TgXuS3 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-4);
  text-align: center;
}

.jmO_L5 {
  width: 72px;
  height: 72px;
  color: var(--icon-neutral-stronger);
  margin-bottom: var(--spacing-3);
}

.pc2fvP {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-180);
  color: var(--text-neutral-dark);
  margin-bottom: var(--spacing-1);
  margin-top: 0;
}

.If7nXq {
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  color: var(--text-neutral-stronger);
  margin-bottom: var(--spacing-3);
  max-width: 300px;
}

.FopvnO {
  margin-top: var(--spacing-1);
}

.ifw_KC .jmO_L5 {
  margin-bottom: var(--spacing-3);
}

.ifw_KC .pc2fvP {
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  margin-bottom: var(--spacing-1);
}

.ifw_KC .If7nXq {
  color: var(--text-neutral-dark);
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/BeneficiaryEmptyState/BeneficiaryEmptyState.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-4);\n  text-align: center;\n}\n\n.icon {\n  width: 72px;\n  height: 72px;\n  color: var(--icon-neutral-stronger);\n  margin-bottom: var(--spacing-3);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-dark);\n  margin-bottom: var(--spacing-1);\n  margin-top: 0;\n}\n\n.description {\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  color: var(--text-neutral-stronger);\n  margin-bottom: var(--spacing-3);\n  max-width: 300px;\n}\n\n.button {\n  margin-top: var(--spacing-1);\n}\n\n.collaboratorsContainer .icon {\n  margin-bottom: var(--spacing-3);\n}\n\n.collaboratorsContainer .title {\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  margin-bottom: var(--spacing-1);\n}\n\n.collaboratorsContainer .description {\n  color: var(--text-neutral-dark);\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TgXuS3`,
	"icon": `jmO_L5`,
	"title": `pc2fvP`,
	"description": `If7nXq`,
	"button": `FopvnO`,
	"collaboratorsContainer": `ifw_KC`
};
module.exports = ___CSS_LOADER_EXPORT___;
